'use strict';

var vendorConsents = require('./vendor-consent.js');
var logger = require('./logger.js');
var localStorageUtils = require('./localStorageUtils.js');

var permutive = window.permutive;
const ccpaConsentType = 'ccpa';
const gdprConsentType = 'gdpr';
const consentStorageKey = 'consentData'; 

function consentGranted () {
    logger.info('Permutive opt_in: true');
	permutive.consent({ 'opt_in': true, 'token': 'CONSENT_CAPTURED' });
}

function consentRefused () {
	logger.info('Permutive consent has not been granted - no data will be collected');
	permutive.consent({ 'opt_in': false });
}

async function handleTcfEvent(eventName) {
    vendorConsents.addTcfApiHandler(eventName,  async () => {
        try {
            // Get stored consent data from localStorage
            const storedConsent = localStorageUtils.getItem(consentStorageKey);
            if (!storedConsent) {
                logger.warn('No consent data found in localStorage');
                consentRefused();
                return;
            }

            // If consent type is 'none', it means no framework applies
            if (storedConsent.type === 'none' && !storedConsent.applies) {
                logger.info('SP [event]: Neither GDPR nor CCPA applies');
                consentGranted();
                return;
            }

            // Handle GDPR consent
            if (storedConsent.type === gdprConsentType) {
                if (storedConsent.applies && storedConsent.granted) {
                    // Use the existing vendor consent check for GDPR
                    vendorConsents.onRetrieveVendorAndPurposeConsents(consentGranted, consentRefused);
                } else {
                    consentRefused();
                }
            }
            // Handle CCPA consent
            else if (storedConsent.type === ccpaConsentType) {
                if (storedConsent.applies && storedConsent.granted) {
                    consentGranted();
                } else {
                    consentRefused();
                }
            }
        } catch (error) {
            logger.error('Error processing consent data:', error);
            consentRefused();
        }
    });
}

permutive.init = function() {
	const eventsToHandle = [
		vendorConsents.eventNames.userActionComplete,
		vendorConsents.eventNames.subsequentPageLoad
	];

	eventsToHandle.forEach(eventName => handleTcfEvent(eventName));
};

module.exports = permutive;